import React, { Component } from 'react'
import { History } from 'containers/pages'
import { routerAdapter } from 'helpers/decorators'

@routerAdapter()
class ParticipantHistory extends Component {
  render() {
    return <History decoActions="participant" {...this.props} />
  }
}

export default ParticipantHistory
